import React, { useEffect, useState } from 'react';
import api from '../api';

const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const [message, setMessage] = useState('');

  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [shippingAddress, setShippingAddress] = useState({
    fullName: '',
    street: '',
    city: '',
    province: '',
    zip: '',
    country: 'Italia'
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await api.get('user/me', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(res.data);
        setName(res.data.name || '');
        setPhoneNumber(res.data.phoneNumber || '');
        setShippingAddress({
          fullName: res.data.shippingAddress?.fullName || '',
          street: res.data.shippingAddress?.street || '',
          city: res.data.shippingAddress?.city || '',
          province: res.data.shippingAddress?.province || '',
          zip: res.data.shippingAddress?.zip || '',
          country: res.data.shippingAddress?.country || 'Italia'
        });
      } catch (error) {
        console.error('Error loading profile:', error);
        setMessage('Error loading profile');
      }
    };
    fetchProfile();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const res = await api.put(
        'user/me',
        { name, phoneNumber, shippingAddress },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage(res.data.message || 'Profile updated');
      setUser(res.data.user);
    } catch (error) {
      console.error('Error updating profile:', error);
      setMessage(error.response?.data?.message || 'Error updating profile');
    }
  };

  if (!user) {
    return <div className="container mt-5">Loading profile...</div>;
  }

  return (
    <div className="container mt-5 mb-5">
      <h2 className="text-success mb-4">My Profile</h2>

      {message && <div className="alert alert-info text-center">{message}</div>}

      <form onSubmit={handleSubmit} className="border rounded p-4 shadow-sm bg-white">
        <h5 className="mb-3 text-success fw-bold">Account Information</h5>

        <div className="mb-3">
          <label className="form-label fw-semibold">Email (not editable)</label>
          <input
            type="email"
            className="form-control"
            value={user.email}
            disabled
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Name</label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your full name"
          />
        </div>

        <div className="mb-4">
          <label className="form-label fw-semibold">Phone Number</label>
          <input
            type="text"
            className="form-control"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="e.g. +39 333 1234567"
          />
        </div>

        <hr />

        <h5 className="mb-3 text-success fw-bold">Shipping Address</h5>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">Full Name</label>
            <input
              type="text"
              className="form-control"
              value={shippingAddress.fullName}
              onChange={(e) => setShippingAddress({ ...shippingAddress, fullName: e.target.value })}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">Street</label>
            <input
              type="text"
              className="form-control"
              value={shippingAddress.street}
              onChange={(e) => setShippingAddress({ ...shippingAddress, street: e.target.value })}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label fw-semibold">City</label>
            <input
              type="text"
              className="form-control"
              value={shippingAddress.city}
              onChange={(e) => setShippingAddress({ ...shippingAddress, city: e.target.value })}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label fw-semibold">Province</label>
            <input
              type="text"
              className="form-control"
              value={shippingAddress.province}
              onChange={(e) => setShippingAddress({ ...shippingAddress, province: e.target.value })}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label fw-semibold">ZIP</label>
            <input
              type="text"
              className="form-control"
              value={shippingAddress.zip}
              onChange={(e) => setShippingAddress({ ...shippingAddress, zip: e.target.value })}
            />
          </div>

          <div className="col-md-12 mb-3">
            <label className="form-label fw-semibold">Country</label>
            <input
              type="text"
              className="form-control"
              value={shippingAddress.country}
              onChange={(e) => setShippingAddress({ ...shippingAddress, country: e.target.value })}
            />
          </div>
        </div>

        <div className="text-end">
          <button className="btn btn-success px-4" type="submit">
            Update Profile
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProfilePage;
